import { ISector } from 'features/settings/topology/types';
import { ExportableResourceService } from 'shared/services/ExportableResourceService';

class TypeService extends ExportableResourceService<ISector> {
  constructor() {
    super('types');
  }
  canDelete = true;
}

export const typeService = new TypeService();
